module.exports = __webpack_public_path__ + "img/horozsleep.a60d1eed.gif";